import { Injectable } from '@angular/core';
import * as Config from '../config';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<UserInterface | null> = new BehaviorSubject<UserInterface | null>(null);
  public currentUser$: Observable<UserInterface | null> = this.currentUserSubject.asObservable();
  public isAuthenticated$: Observable<boolean>;
  public isAuthenticatedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  constructor(
    public storage: StorageService,
    public router: Router,
    public http: HttpClient,
									
  ) {
      this.loadToken();
      this.isAuthenticated$ = this.isAuthenticatedSubject.asObservable().pipe(
        filter(val => val != null)
      );
   }

  // Load accessToken on startup
  private async loadToken() { 
    try {
      const user = await this.storage.get('User'); 
      if (user) {
        this.currentUserSubject.next(user);
        console.log("Current user: ", user);
        this.isAuthenticatedSubject.next(true);
      } else {
        this.isAuthenticatedSubject.next(false);
      }
    } catch (error) {
      console.error('Error loading token:', error);
      this.isAuthenticatedSubject.next(false);
    }
  }

  get isUserLoggedIn() {
    return this.isAuthenticatedSubject.getValue();
  }

  get getCurrentUserObserveable() {
    return this.currentUserSubject.pipe(filter(user => user!=null));
  }
  
  get getCurrentUser() {
    return this.currentUserSubject.getValue();
  }

  public async setUser(user: UserInterface): Promise<void> { 
    console.log("Set user: ", user);                                    
    this.currentUserSubject.next(user);
    try {
      await this.storage.set('User', user);    
    } catch (error) {
      console.error('Error setting user:', error);
    }
  }

  public async setAvatar(url: string): Promise<void> { 
    console.log("Set avatar: ", url);                                    
    let user = this.currentUserSubject.getValue();
    user.avatar = url;
    await this.setUser(user);
  }

  public async setDisplayName(name: string): Promise<void> { 
    console.log("Set new displayname: ", name);                                    
    let user = this.currentUserSubject.getValue();
    user.displayname = name;
    await this.setUser(user);
  }
  
  public async setEmail(email: string): Promise<void> { 
    console.log("Set new emal: ", email);                                    
    let user = this.currentUserSubject.getValue();
    user.email = email;
    await this.setUser(user);
  }

  public async logOut(): Promise<void> {
    this.currentUserSubject.next(null);
    this.isAuthenticatedSubject.next(false);                                  
    this.router.navigateByUrl('/menu/login');
    try {
      await this.storage.clear();  
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  }


  doLogin(username, password) : Observable<any>{
    return this.http.post(Config.API_ENDPOINT + 'authenticate_user',{
      username: username,
      password: password    
    }).pipe(
      map((res:any) =>
      {
        if(res.success == true) { 
          console.log("Setting user");      
          this.setUser({
              token: res.data.token,
              username: res.data.username,
              displayname: res.data.displayname,
              email: res.data.email,
              avatar: res.data.avatar,
              id: res.data.id,
              user_type: res.data.user_type,
              secret_token: res.data.secret
            }); 
            this.isAuthenticatedSubject.next(true);
          }               
          return res;
      })      
    )
  } 
}

export interface UserInterface {
  token: string,
  username: string,
  displayname: string,
  email: string,
  avatar: string,
  id: number,
  secret_token: string,
  user_type: number;
}
